import React from "react";
import { Box, Button } from "@mui/material";
import MicrophoneButton from "./MicrophoneButton";
import VideoButton from "./VideoButton";

interface PreJoinControlBarProps {
  audioEnabled: boolean;
  videoEnabled: boolean;
  audioDevices: MediaDeviceInfo[];
  videoDevices: MediaDeviceInfo[];
  selectedAudioDevice: string;
  selectedVideoDevice: string;
  onAudioToggle: () => void;
  onVideoToggle: () => void;
  onAudioDeviceChange: (deviceId: string) => void;
  onVideoDeviceChange: (deviceId: string) => void;
  onJoin?: () => void;
  showJoinButton?: boolean;
}

const PreJoinControlBar: React.FC<PreJoinControlBarProps> = ({
  audioEnabled,
  videoEnabled,
  audioDevices,
  videoDevices,
  selectedAudioDevice,
  selectedVideoDevice,
  onAudioToggle,
  onVideoToggle,
  onAudioDeviceChange,
  onVideoDeviceChange,
  onJoin,
  showJoinButton = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      {/* Control Bar */}
      <Box
        sx={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {/* Microphone Button */}
        <MicrophoneButton
          enabled={audioEnabled}
          onToggle={onAudioToggle}
          devices={audioDevices}
          activeDeviceId={selectedAudioDevice}
          onDeviceChange={onAudioDeviceChange}
        />

        {/* Video Button */}
        <VideoButton
          enabled={videoEnabled}
          onToggle={onVideoToggle}
          devices={videoDevices}
          activeDeviceId={selectedVideoDevice}
          onDeviceChange={onVideoDeviceChange}
        />
      </Box>

      {/* Join Button */}
      {showJoinButton && onJoin && (
        <Button variant="contained" onClick={onJoin}>
          Join Call
        </Button>
      )}
    </Box>
  );
};

export default PreJoinControlBar;
